import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const ReservationSelectionContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const DatePickerContainer = styled.div`
  margin-bottom: 20px;
`
export const BtnContainer = styled.div`
  margin-top: 10px;
  display: flex;
  width: 100%;
  justify-content: end;
`

export const ReservationContainer = styled.div<{ withLoader?: boolean }>`
  padding: 32px;
  max-width: 1200px;
  margin: auto;
  width: 100%;
  overflow-x: hidden;

  ${({ withLoader }) =>
    withLoader &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100vh;
    `}
`
